import React from 'react';
import './dadosComplementares.scss';

//Componentes
import Breadcrumbs from '../../components/breadcrumbs';
import NavigationButtons from '../../components/navigationButtons';
import Field from '../../components/field';
import Dropdown from '../../components/dropdown';
// import Toggle from '../../components/toggle';
import Typeahead from '../../components/typeahead';
import CheckObligation from '../../components/checkObligation'
import Utils from '../../helper/validateUtils'


class DadosComplementares extends React.Component {

  componentWillMount() {
    this.formFields = []
    let { getListDadosComplementaresEstadoCivilAction, getListDadosComplementaresGeneroAction, getListDadosComplementaresPaisAction } = this.props;
    getListDadosComplementaresEstadoCivilAction();
    getListDadosComplementaresGeneroAction();
    // getListDadosComplementaresPaisAction();
  }

  render() {

    let {
      formDados,
      dadosComplementares_genero,
      dadosComplementares_estadoCivil,
      dadosComplementares_PaisNascimento,
      typeaHeadDadosPaisList,
      dropdownDadosGeneroList,
      dropdownDadosEstadoCivilList,
      // dadosComplementares_pessoaAmericana,
      dadosComplementares_paisFiscal,
      loadingDadosComplementaresPais,
      loadingDadosComplementaresGenero,
      loadingDadosComplementaresEstadoCivil
    } = this.props.dadosComplementares;


    let {
      changeDadosComplementaresValueForm,
      handleChangeDadosGenero,
      handleChangeDadosEstadoCivil,
      // handleChangeDadosFlagPessoaAmericana,
      handleChangeTypeahead,
      // handleChangePessoaAmericana
    } = this.props;

    const {listPais, loadingDdi} = this.props.ddiReducer;

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs />
        </div>

        {/* <CheckObligation field="dadosComplementares_genero">
          {(validacoes) =>
            <div className="col-50">
              <Dropdown
                value={dadosComplementares_genero}
                onChange={handleChangeDadosGenero}
                dataSource={dropdownDadosGeneroList}
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                loading={loadingDadosComplementaresGenero}
                name="dadosComplementares_genero"
                label="Genero" />
            </div>}
        </CheckObligation> */}

        <CheckObligation field="dadosComplementares_estadoCivil">
          {(validacoes) =>
            <div className="col-100">
              <Dropdown
                value={dadosComplementares_estadoCivil}
                onChange={handleChangeDadosEstadoCivil}
                dataSource={dropdownDadosEstadoCivilList}
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                loading={loadingDadosComplementaresEstadoCivil}
                name="dadosComplementares_estadoCivil"
                label="Estado Civil" />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosComplementares_nomeConjuge" fieldConditional={{ 'dadosComplementares_estadoCivil': dadosComplementares_estadoCivil }}>
          {(validacoes) =>
            <div className="col">
              <Field
                type="text"
                placeholder="Digite o nome do Cônjugue"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Nome do Cônjuge"
                name="dadosComplementares_nomeConjuge"
                minlength={3}
                maxlength={100}
                value={formDados.dadosComplementares_nomeConjuge}
                onChange={changeDadosComplementaresValueForm} />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosComplementares_cpfConjuge" fieldConditional={{ 'dadosComplementares_estadoCivil': dadosComplementares_estadoCivil }}>
          {(validacoes) =>
            <div className="col-50">
              <Field
                type="cpf"
                placeholder="999.999.999-99"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="CPF do Cônjuge"
                name="dadosComplementares_cpfConjuge"
                mask="999.999.999-99"
                pattern="^\d{3}\x2E\d{3}\x2E\d{3}\x2D\d{2}$"
                value={formDados.dadosComplementares_cpfConjuge}
                validateSync={Utils.isCPF}
                onChange={changeDadosComplementaresValueForm}

              />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosComplementares_dataNascimentoConjuge" fieldConditional={{ 'dadosComplementares_estadoCivil': dadosComplementares_estadoCivil }}>
          {(validacoes) =>
            <div className="col-50">
              <Field
                type="date"
                placeholder="12/06/1980"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Data de Nascimento do Conjuge"
                name="dadosComplementares_dataNascimentoConjuge"
                validateSync={() => Utils.isDate('<=', formDados.dadosComplementares_dataNascimentoConjuge, new Date().setFullYear(new Date().getFullYear() - 16), 'Idade menor que 16 anos')}
                value={formDados.dadosComplementares_dataNascimentoConjuge}
                onChange={changeDadosComplementaresValueForm}
                mask="99/99/9999"
              />
            </div>}
        </CheckObligation>

        <CheckObligation field="dadosComplementares_nomeMae">
          {(validacoes) =>
            <div className="col">
              <Field
                type="text"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Nome da Mãe"
                name="dadosComplementares_nomeMae"
                minlength={3}
                maxlength={100}
                value={formDados.dadosComplementares_nomeMae}
                onChange={changeDadosComplementaresValueForm} />
            </div>}
        </CheckObligation>


        <CheckObligation field="dadosComplementares_nomePai">
          {(validacoes) =>
            <div className="col">
              <Field
                type="text"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Nome do Pai"
                name="dadosComplementares_nomePai"
                minlength={3}
                maxlength={100}
                value={formDados.dadosComplementares_nomePai}
                onChange={changeDadosComplementaresValueForm} />
            </div>}
        </CheckObligation>


        <CheckObligation field="dadosComplementares_paisFiscal">
          {(validacoes) =>
            <div className="col-50">
              <Typeahead
                dataSource={listPais}
                fieldValue={"IdPais"}
                required={validacoes.obrigatorio}
                fieldText={"Nome"}
                onChange={handleChangeTypeahead}
                value={dadosComplementares_paisFiscal}
                loading={loadingDdi}
                name="dadosComplementares_paisFiscal"
                label="País de Domicílio Fiscal"
                returnObject={this.createRefFields}
              />
            </div>}
        </CheckObligation>


        {/* <CheckObligation field="dadosComplementares_pessoaAmericana">
          {(validacoes) =>
            <div className="col-50">
              <div className="col-togle-p">
                <p>Possui domicílio fiscal nos Estados Unidos da América, nacionalidade ou cidadania norte-americana ou Green Card?</p>
              </div>
              <div className="col-togle">
                <Toggle 
                  id="dadosComplementares_pessoaAmericana" 
                  check={dadosComplementares_pessoaAmericana} 
                  onChange={(ev) => {
                    handleChangePessoaAmericana(ev.value); 
                    return handleChangeDadosFlagPessoaAmericana(ev);
                  }} />
              </div>          
            </div>}
        </CheckObligation> */}


        {/* <CheckObligation field="dadosComplementares_SocialSecurityNumber" fieldConditional={{ 'dadosComplementares_pessoaAmericana': dadosComplementares_pessoaAmericana }}>
          {(validacoes) =>
            <div className="col-50">
              <Field
                type="number"
                placeholder="Social Security Number"
                required={validacoes.obrigatorio}
                returnObject={this.createRefFields}
                label="Social Security Number"
                name="dadosComplementares_SocialSecurityNumber"
                minlength={3}
                maxlength={11}
                value={formDados.dadosComplementares_SocialSecurityNumber}
                onChange={changeDadosComplementaresValueForm} />
            </div>}
        </CheckObligation> */}


        <CheckObligation field="dadosComplementares_PaisNascimento" >
          {(validacoes) =>
            <div className="col-50">
              <Typeahead
                dataSource={listPais}
                fieldValue={"IdPais"}
                required={validacoes.obrigatorio}
                fieldText={"Nome"}
                onChange={handleChangeTypeahead}
                returnObject={this.createRefFields}
                value={dadosComplementares_PaisNascimento}
                loading={loadingDdi}
                name="dadosComplementares_PaisNascimento"
                label="País de Nascimento" />
            </div>}
        </CheckObligation>


        <div className="col">
          <NavigationButtons history={this.props.history} validateFields={this.validateFields} />
        </div>
      </section>
    );
  }


  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = async () => {
    let list = []
    let countMounted = 0

    return new Promise(resolve => {
      if (Object.keys(this.formFields).length === 0) {
        resolve([])
      }

      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted) {
          countMounted++
          this.formFields[key].validate(this.formFields[key].input)

            // eslint-disable-next-line no-loop-func
            .then(r => {
              list.push({ name: this.formFields[key].props.name, valid: r })

              if (countMounted === list.length) {
                resolve(list)
              }
            })
        }
      }
    })
  }
}

export default DadosComplementares;
